//Components
import "../icon/index";
import "../dialog/dialog";
import "../forms/button/index";
import "../forms/input-text/index";

import { CustomElement, Component } from "../../core/CustomElement";
import { DiscussionType } from "../../core/types/Discussion";
import { CCCIcon } from "../icon/index";
import CCCDialog from "../dialog/dialog";
import { CCCInputText } from "../forms/input-text";

export interface CCCDiscussionShareState {
  type: DiscussionType;
}

@Component("ccc-discussion-share", {
  template: require("./DiscussionShareTemplate.html").default,
  style: require("./DiscussionShareStyle.scss").default,
  observedAttributes: ["type"],
})
export class CCCDiscussionShare extends CustomElement {
  $icon: CCCIcon = null;
  $dialog: CCCDialog = null;
  link: string = "";
  state: CCCDiscussionShareState = {
    type: DiscussionType.discussion,
  };

  connectedCallback(): void {
    this.link = window.location.href;
    this.$icon = this.shadowDom.querySelector("ccc-icon");
    this.$dialog = this.shadowDom.querySelector("ccc-dialog");

    this.$icon.addEventListener("click", this.openDialog.bind(this));

    const $button = this.$dialog.querySelector("ccc-button");

    $button.addEventListener(
      "ccc-button-click",
      this.copyToClipboard.bind(this)
    );
  }

  copyToClipboard(): void {
    navigator.clipboard
      .writeText(this.link)
      .then(() => {
        this.displayText();
      })
      .catch(() => {
        alert("Cannot copy");
      });
  }

  displayText(): void {
    const text = this.$dialog.querySelector(
      ".ccc-discussion-share-dialog-button-text"
    );

    text.classList.add("opened");

    setTimeout(() => {
      text.classList.remove("opened");
    }, 1500);
  }

  openDialog(): void {
    this.addLinkToInput();
    this.$dialog.open();
  }

  addLinkToInput(): void {
    if (this.state.type === DiscussionType.event) {
      this.link = this.link.replace(
        "events/",
        "categories/ccc-events?eventname="
      );
    }

    const $input: CCCInputText = this.$dialog.querySelector(
      "ccc-input-text"
    ) as CCCInputText;

    $input.setValue(this.link);
  }
}
